var tmp ={
    home_page: function(){
        $('.airq_question').on('click', function(){
            $(this).toggleClass('active');
            $(this).next('.airq_answer').slideToggle();
        });
    },
    slider: function(){


             $('.dlrtxt_slider').slick({
                dots: false,
                infinite: true,
                speed: 700,   
                arrows: true,
                autoplay: false
            });

            $('.blat_slider').slick({
                dots: false,
                infinite: true,
                speed: 700, 
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 2500, 
                arrows: false
            });

            $('.pdrv_slider').slick({
                dots: false,
                infinite: false,
                speed: 300, 
                slidesToShow: 1,
                slidesToScroll: 1
            });
            setTimeout(() => {
                 $('.grid__slider').slick({
                    dots: true,
                    infinite: false,
                    speed: 300, 
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    responsive: [
                        {
                        breakpoint: 1025,
                            settings: {
                                slidesToShow: 2 
                            }
                        },                 
                        {
                        breakpoint: 521,
                            settings: {
                                slidesToShow: 1 
                            }
                        }
                    
                    ]
                 });
            }, 2500);
           


            $('.lstg_slick').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                        dots: true
                    }
                },                 
                {
                breakpoint: 521,
                    settings: {
                        slidesToShow: 1,
                        dots: true
                    }
                } 
             ]
            });

            $('.slider_slick .blog__posts').slick({
                dots: false,
                infinite: false,
                speed: 300, 
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 2500, 
                arrows: false
            });
    },
    application_form: function(){ 

        $('.aptfbtn_item').on('click', function(){

            var id = parseInt($(this).closest('.aptfbtn_grid').data('id'));
            if($(this).hasClass('aptfbtn_prev')){
                id -= 1; 
            }else{
                id += 1; 
            }
                $('html, body').animate({
                    scrollTop: $('.aptf_'+id).offset().top
                }, 800); 
        });
 

 
        const form = document.getElementById('contactForm');
        const statusMsg = document.getElementById('statusMessage');
        const submitBtn = document.getElementById('submitBtn');
        
       const positive = [
                        "wellness",
                        "luxury",
                        "sophisticated",
                        "holistic",
                        "clean",
                        "support",
                        "solution",
                        "remedy",
                        "balance",
                        "regulation",
                        "nervous system",
                        "stress response",
                        "root cause",
                        "whole body",
                        "Ayurveda",
                        "long-term",
                        "restore",
                        "support vs suppress",
                        "biology",
                        "hormonal harmony",
                        "dinacharya",
                        "ritual",
                        "long-term",
                        "restore",
                        "support vs suppress",
                        "biology",
                        "hormonal harmony",
                        "inflammation",
                        "sleep",
                        "nutrition",
                        "adaptogens",
                        "curious",
                        "open",
                        "exploring",
                        "looking for alternatives",
                        "questioning",
                        "want to get off",
                        "concerned about side effects",
                        "prefer natural",
                        "hormones",
                        "endocrine",
                        "insulin resistance",
                        "thyroid",
                        "cycle",
                        "androgens",
                        "systemic",
                        "routine",
                        "ritual",
                        "consistency",
                        "massage",
                        "breathwork",
                        "meditation",
                        "yoga",
                        "sauna",
                        "cold plunge",
                        "walks",
                        "strength training",
                        "friends ask me",
                        "group chat",
                        "host",
                        "dinner",
                        "salon",
                        "women in my circle",
                        "community",
                        "introduced",
                        "referrals",
                        "Oribe",
                        "Kérastase",
                        "Miriam Quevedo",
                        "Leonor Greyl",
                        "sachajuan",
                        "Vegamour",
                        "Briogeo",
                        "Nécessaire"
                    ];
         
       const Negative = [
                            "only thing that works",
                            "must stay on",
                            "can't stop",
                            "need my prescription",
                            "natural doesn't work",
                            "quick fix",
                            "results only",
                            "don't believe in holistic",
                            "PREGNANT",
                            "NURSING",
                            "DIABETES",
                            "RECENT_SURGERY_ANESTHESIA",
                            "RADIATION_HISTORY",
                            "COMPLEX_PRESCRIPTIONS",
                            "RX_HAIRLOSS",
                            "GLP1",
                            "HORMONE_THERAPY",
                            "LOW_CONFIDENCE",
                            "ozempic",
                            "wegovy",
                            "mounjaro",
                            "zepbound",
                            "semaglutide",
                            "tirzepatide",
                            "finasteride",
                            "spironolactone",
                            "dutasteride",
                            "oral minoxidil",
                            "minoxidil",
                            "rogaine",
                            "hormone therapy",
                            "hrt",
                            "testosterone",
                            "estrogen",
                            "progesterone",
                            "birth control",
                            "oral contraceptive"
                        ];


        
         const life_transition_p = [ "divorce", "grief", "relocation" ];
         const life_transition_n = [ "health recovery", "caretaking", "career change"];
         const referrer_name = ["Shivangi", "Van Gogh", "Purple PR", "Wendy", "Zoller", "Shelly", "Justice"];
 
         var klayiyo_list = '';
         var k_list =  [
                            {  id: "Y5aGF2",  list_name: "SUPERNOVA"   },
                            {  id: "X52ntW", list_name: "Rejected"  },
                            {  id: "TJ4nva", list_name: "Ledger only"   },
                            {  id: "QQQUsd",  list_name: "Ledger nurture"   },
                            {  id: "Vyvgaa",  list_name: "Strong alignment"   },
                            {  id: "VbmYzH",  list_name: "Core Exclusive" },
                            { id: "Vi2f5C",   list_name: "Star Mapping" },
                            { id: "Ve8bXB",   list_name: "Aligned" },
                            { id: "YjcqUd",   list_name: "Nurture" },
                            { id: "WPgyCM",   list_name: "Reject" }
                        ];
            

        function showMessage(message, type) {
            statusMsg.textContent = message;
            statusMsg.className = `message ${type}`;
            statusMsg.style.display = 'block';
            
            setTimeout(() => {
                statusMsg.style.display = 'none';
            }, 5000);
        }

        /*
        $('.aptfbx_heading').on('click', function(){
               var email = $('.klaviyo-form-S7pZPM [type="email"]').val();
                    var phone = $('.klaviyo-form-S7pZPM [type="tel"]').val();
                    console.log(email);
                var formId = "S7pZPM"; 
                var $form = $('[data-testid="klaviyo-form-' + formId + '"]');

                if($form.length){
                    $form[0].dispatchEvent(new Event('submit', {
                        bubbles:true,
                        cancelable:true
                    }));
                }
        });
        */

        if(form) {
            form.addEventListener('submit', async (e) => {
                e.preventDefault();

                

                const bsd = $(e.target).data('view');
                const btb = $(e.target).data('table'); 
                const act = 'patHUgup0Vwp9dJ9O.44a7b1179c3de520aced2d1c5ff07342ebb62f3960ead727b33ba8c2f38048eb';

                var only_table = 1;
                
                //console.log($(e.target).data('view'));
                //console.log($(e.target).data('table'));
                if($(e.target).hasClass('shortend')){
                    only_table = 0;
                    var email = $('.klaviyo-form-S7pZPM [type="email"]').val();
                    var phone = $('.klaviyo-form-S7pZPM [type="tel"]').val();
                    $('.klaviyo_email').val(email);
                    $('.klaviyo_phone').val(phone);
                } 

                const formData = new FormData(form);
                const data = {};
                for (const [key, value] of formData.entries()) {
                    data[key] = value;
                }
                //console.log(data);
        
                
                var totalPoints = check_points();  
                data.points = totalPoints.toString(); 

                if(only_table){                
                    if(klayiyo_list ==''){
                        klayiyo_list = find_klayiyo_list(totalPoints); 
                    } 
                }else{
                     klayiyo_list = find_klayiyo_list_1(totalPoints);

                        var formId = "S7pZPM"; 
                        var $form = $('[data-testid="klaviyo-form-' + formId + '"]');

                        if($form.length){
                            $form[0].dispatchEvent(new Event('submit', {
                                bubbles:true,
                                cancelable:true
                            }));
                        }
                }
                
                setTimeout(function(){
                    console.log(data.email); 
                    add_value_klaviyo(data.first_name, data.last_name, data.mobile_number, data.internal_utm, data.email, klayiyo_list); 
                },900);
                
                console.log("Airtable Data: ", data);
                 

                submitBtn.disabled = true;
                submitBtn.textContent = 'Sending...';
                
                
                try {
                    const response = await fetch(`https://api.airtable.com/v0/${bsd}/${btb}`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${act}`,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                                    fields: data
                                })
                    });

                    if (response.ok) {
                        const data = await response.json();
                        //showMessage('Message sent successfully!', 'success');
                        $('#statusMessage').show();
                        $('#contactForm').hide();
                        //form.reset();
                    } else {
                        const errorData = await response.json();
                        throw new Error(errorData.error?.message || 'Submission failed');
                    }
                } catch (error) {
                    showMessage(`Error: ${error.message}`, 'error');
                } finally {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Send Message';
                }
            });
        }

        function add_value_klaviyo(first_name, last_name, phone, utm_source, email, klayiyo_list){
               
           
         window._learnq = window._learnq || [];        
        _learnq.push(['identify', {
            $email: email,
            $phone_number: phone,
            $sms_consented: true,  
            utm_source: utm_source
        }]); 
    $.ajax({
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        type: "POST",
        dataType: "json",
        data: {
            g: klayiyo_list,
            email: email,
            first_name: first_name,
            last_name: last_name,
            phone_number: phone,
            sms_consent: true,
            consent: true,
            $consent: ['sms', 'email'],
            $extra_fields: JSON.stringify({
                utm_source: utm_source,
                sms_consented: true
            })
        },
        success: function(res){
            console.log("Subscribe response:", res); 
        },
        error: function(xhr){
            console.log("Subscribe error:", xhr.responseText); 
        }
    });
 
            
               
        }

        function find_klayiyo_list(points){
            var list = '';
            if(points < 80){
                list = k_list[2]['id'];
            }else if(points < 145){
                list = k_list[3]['id'];
            }else if(points < 205){
                list = k_list[4]['id'];              
            }else if(points < 255){
                list = k_list[5]['id'];
            }else{
                 list = k_list[6]['id'];
                  
            }
            return list;
        }

        function find_klayiyo_list_1(points){
            var list = '';
            if(points < 7){
                list = k_list[9]['id'];
            }else if(points < 15){
                list = k_list[8]['id'];              
            }else{
                 list = k_list[7]['id'];                  
            }
            return list;
        }

       
       function check_points(){  
            const data = {
                fields: {},    
                totalPoints: 0
            };

            const $form = $('#contactForm');

            // RADIOS
            $form.find('input.check_points_input[type="radio"]:checked').each(function () {
                const $el = $(this);
                const name = $el.attr('name');
                const val = $el.val();
                const points = parseFloat($el.data('points')) || 0;

                data.fields[name] = { value: val, points: points, type: "radio" }; 
                if (points > 0){
                    data.totalPoints += points;
                }else{
                    klayiyo_list = k_list[1]['id'];
                } 
            });

            // TEXT + TEXTAREA
            $form.find('input.check_points_input:not([type="radio"]):not([type="checkbox"]), textarea.check_points_input').each(function () {
                const $el = $(this);
                const name = $el.attr('name');
                const val = ($el.val() || "").trim();

                if (!name) return;
                if (val === "") return;

                const basePoints = parseFloat($el.data('points')) || 0;
                const plus = parseFloat($el.data('plus')) || 0;
                const minLen = parseFloat($el.data('min')) || 0;

                let points = basePoints;

                 if(plus != 0 && Negative != 0){
                    const addon_value = check_addon_points(positive, Negative, val);
                   // console.log(val+' :'+ addon_value);
                    if(addon_value == 1){
                        points +=plus;
                    }else if(addon_value == 2){
                        points -=minLen;
                    } 
                }
                
                
                if($el.hasClass('life_transition')){
                    const addon_value = check_addon_points(life_transition_p, life_transition_n, val);
                    const plus = parseFloat($el.data('plus')) || 0;
                    const minLen = parseFloat($el.data('plus2')) || 0;

                    if(addon_value == 1){
                        points +=plus;
                    }else if(addon_value == 2){
                        points +=minLen;
                    }
                } 

                if($el.hasClass('referrer_name')){
                    const v = String(val || "").toLowerCase(); 
                    const rm  = new Set(referrer_name.map(v => v.toLowerCase().trim()));
                    if (!rm.has(v)) {
                        points -=basePoints;                        
                    }else{
                        klayiyo_list = k_list[0]['id'];
                    }
                }
                  
                data.fields[name] = { value: val, points: points, type: $el.is('textarea') ? "textarea" : "text" };
                if (points > 0) data.totalPoints += points;
            });
 
            // CHECKBOXES (multiple select)
            $form.find('input.check_points_input[type="checkbox"]:checked').each(function () {
                const $el = $(this);
                const name = $el.attr('name');

                if (!name) return;

                var val = $el.val();
                const points = parseFloat($el.data('points')) || 0;

                // console.log(val);
                // console.log(data.fields[name]);

                if (!data.fields[name]) {
                     data.fields[name] = { value: val, points: 0, type: "checkbox" }; 
                }else{
                    val = val+' | '+ data.fields[name].value;
                    data.fields[name].value = val;
                } 
                //console.log(data.fields[name]);

                // Add points
                if (points > 0) {
                    data.fields[name].points += points;
                    data.totalPoints += points;
                } else {
                    klayiyo_list = k_list[1]['id'];
                }
            });


              console.log(data);
              return data.totalPoints;
            }


            function check_addon_points(plus, min, value){
                 var r_point = 0; 
                   const plusSet = new Set(plus.map(v => v.toLowerCase().trim()));
                  const minSet  = new Set(min.map(v => v.toLowerCase().trim()));

                var v = String(value || "").toLowerCase(); 
                if (plusSet.has(v)) {
                    r_point = 1;
                } else if (minSet.has(v)) {
                    r_point = 2;
                } 
                return r_point;
            }



            var urlParams = new URLSearchParams(window.location.search);
            var utmSource = urlParams.get('utm_source'); 
           // console.log(utmSource);   
            if(utmSource){
                $('.aptfhd_input[name="internal_utm"]').val(utmSource);
            }  

  
    } 


}
$(function() {
    tmp.home_page();
    tmp.slider();
    tmp.application_form();
})